<table class="mat-calendar-table month-view">
  <thead class="mat-calendar-table-header">
    <tr>
      @for(day of _weekdays; track day){
        <th [attr.aria-label]="day.long">{{day.narrow}}</th>
      }
    </tr>
    <tr>
      <th class="mat-calendar-table-header-divider" colspan="7" aria-hidden="true"></th>
    </tr>
  </thead>
  <tbody app-sx-calendar-body 
    [label]="_monthLabel" 
    [rows]="_weeks" 
    [todayValue]="_todayDate" 
    [selectedValue]="_selectedDate"
    [labelMinRequiredCells]="3" 
    [activeCell]="_dateAdapter.getDate(activeDate) - 1" 
    (selectedValueChange)="_dateSelected($event)"
    (keydown)="_handleCalendarBodyKeydown($event)">
  </tbody>
</table>